import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtINR, fmtDate, san, loadLogoDataUrl, drawITOHeader, resolveBrandName } from "./common";

export async function generateQuotePdf(qt, company) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const logo = await loadLogoDataUrl();
  let y = drawITOHeader(doc, company, logo, "QUOTATION", resolveBrandName(qt, company), "TRANSPORT DIVISION  |  QUOTATION");

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold"); doc.text("Quote No:", 12, y); doc.setFont("helvetica", "normal"); doc.text(String(qt.quote_number || ""), 36, y);
  doc.setFont("helvetica", "bold"); doc.text("Date:", 110, y); doc.setFont("helvetica", "normal"); doc.text(fmtDate(qt.quote_date), 124, y);
  if (qt.valid_until) { doc.setFont("helvetica", "bold"); doc.text("Valid Until:", 150, y); doc.setFont("helvetica", "normal"); doc.text(fmtDate(qt.valid_until), 174, y); }
  y += 4;

  autoTable(doc, {
    startY: y, theme: "grid", styles: { fontSize: 9, cellPadding: 2 },
    headStyles: { fillColor: [240, 240, 240], textColor: 40, fontStyle: "bold" },
    head: [["Quotation For", "Route"]],
    body: [[
      `${san(qt.customer_name) || ""}\n${san(qt.customer_address) || ""}${qt.customer_attn ? `\nKind Attn: ${san(qt.customer_attn)}` : ""}\nGST: ${qt.customer_gst || "-"}`,
      `${qt.from_location || "-"}  ->  ${qt.to_location || "-"}`,
    ]],
    columnStyles: { 0: { cellWidth: 116 }, 1: { cellWidth: 66 } },
  });
  y = doc.lastAutoTable.finalY + 3;

  const body = (qt.items || []).filter((it) => it.description || it.amount).map((it, i) =>
    [String(i + 1), san(it.description), String(it.quantity), fmtINR(it.rate), fmtINR(it.amount)]);
  autoTable(doc, {
    startY: y, theme: "grid", styles: { fontSize: 9, cellPadding: 2.5 },
    headStyles: { fillColor: [200, 30, 30], textColor: 255, fontStyle: "bold" },
    head: [["#", "Description", "Qty", "Rate", "Amount"]],
    body: body.length ? body : [["", "—", "", "", ""]],
    columnStyles: { 0: { cellWidth: 10 }, 2: { halign: "right", cellWidth: 18 }, 3: { halign: "right", cellWidth: 28 }, 4: { halign: "right", cellWidth: 32 } },
  });
  y = doc.lastAutoTable.finalY + 4;

  doc.setFontSize(10);
  doc.text("Subtotal:", 158, y, { align: "right" }); doc.text(fmtINR(qt.subtotal), 196, y, { align: "right" }); y += 6;
  if (Number(qt.freight_estimate || 0) > 0) {
    doc.text("Freight Estimate:", 158, y, { align: "right" }); doc.text(fmtINR(qt.freight_estimate), 196, y, { align: "right" }); y += 6;
  }
  doc.setFont("helvetica", "bold"); doc.setFontSize(12);
  doc.text("ESTIMATED TOTAL:", 158, y, { align: "right" }); doc.text(fmtINR(qt.total), 196, y, { align: "right" });
  y += 10;

  doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(110);
  doc.text("This is a quotation only and not a tax invoice. Rates are subject to change and valid until the date mentioned above.", 12, y);
  doc.setTextColor(0); y += 8;

  if (qt.notes) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.text("Notes:", 12, y);
    doc.setFont("helvetica", "normal");
    doc.text(doc.splitTextToSize(san(qt.notes), 186), 12, y + 5);
  }

  doc.setFont("helvetica", "bold"); doc.setFontSize(8);
  doc.text("All Subject to Mumbai Jurisdiction Only", 105, 268, { align: "center" });
  doc.setFont("helvetica", "normal");
  doc.text("For " + resolveBrandName(qt, company), 196, 278, { align: "right" });
  doc.text("Authorised Signatory", 196, 285, { align: "right" });

  doc.save(`Quotation-${qt.quote_number || "draft"}.pdf`);
}
